import CryptoJS from 'crypto-js'

function initAes (keyStr, n) {
  if (keyStr.length < n) {
    throw new Error('n过大')
  }
  return keyStr.substr(n).concat(keyStr.substr(0, n))
}

// 加密
function encrypt (word, aesKey) {
  let key = CryptoJS.enc.Utf8.parse(aesKey)
  let srcs = CryptoJS.enc.Utf8.parse(word)
  let encrypted = CryptoJS.AES.encrypt(srcs, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  })
  return encrypted.toString()
}

// 解密
function decrypt (word, aesKey) {
  let key = CryptoJS.enc.Utf8.parse(aesKey)
  let decrypt = CryptoJS.AES.decrypt(word, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  })
  return CryptoJS.enc.Utf8.stringify(decrypt).toString()
}

export default {
  initAes,
  encrypt,
  decrypt
}
